/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { InstructionsDto } from './InstructionsDto';
import {
    InstructionsDtoFromJSON,
    InstructionsDtoFromJSONTyped,
    InstructionsDtoToJSON,
} from './InstructionsDto';
import type { ManufacturerDto } from './ManufacturerDto';
import {
    ManufacturerDtoFromJSON,
    ManufacturerDtoFromJSONTyped,
    ManufacturerDtoToJSON,
} from './ManufacturerDto';
import type { TaskTypeBase } from './TaskTypeBase';
import {
    TaskTypeBaseFromJSON,
    TaskTypeBaseFromJSONTyped,
    TaskTypeBaseToJSON,
} from './TaskTypeBase';

/**
 * 
 * @export
 * @interface SystemInfoDto
 */
export interface SystemInfoDto {
    /**
     * 
     * @type {ManufacturerDto}
     * @memberof SystemInfoDto
     */
    manufacturer: ManufacturerDto;
    /**
     * 
     * @type {InstructionsDto}
     * @memberof SystemInfoDto
     */
    instructions: InstructionsDto;
    /**
     * 
     * @type {string}
     * @memberof SystemInfoDto
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof SystemInfoDto
     */
    productVersion: string;
    /**
     * 
     * @type {string}
     * @memberof SystemInfoDto
     */
    assemblyVersion: string;
    /**
     * 
     * @type {string}
     * @memberof SystemInfoDto
     */
    siteName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SystemInfoDto
     */
    hostName: string;
    /**
     * 
     * @type {string}
     * @memberof SystemInfoDto
     */
    domainName: string;
    /**
     * 
     * @type {string}
     * @memberof SystemInfoDto
     */
    environmentName: string;
    /**
     * 
     * @type {boolean}
     * @memberof SystemInfoDto
     */
    isPrototype: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SystemInfoDto
     */
    useLiveTranslations: boolean;
    /**
     * 
     * @type {string}
     * @memberof SystemInfoDto
     */
    appInsightConnectionString: string;
    /**
     * 
     * @type {string}
     * @memberof SystemInfoDto
     */
    installationDate: string;
    /**
     * 
     * @type {string}
     * @memberof SystemInfoDto
     */
    releaseDate: string;
    /**
     * 
     * @type {string}
     * @memberof SystemInfoDto
     */
    readonly fqdn: string;
    /**
     * 
     * @type {Array<TaskTypeBase>}
     * @memberof SystemInfoDto
     */
    taskTypes: Array<TaskTypeBase>;
    /**
     * 
     * @type {string}
     * @memberof SystemInfoDto
     */
    $type?: SystemInfoDtoTypeEnum;
}


/**
 * @export
 */
export const SystemInfoDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedSystemComponentDtoSystemInfoDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.SystemComponent.Dto.SystemInfoDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type SystemInfoDtoTypeEnum = typeof SystemInfoDtoTypeEnum[keyof typeof SystemInfoDtoTypeEnum];


/**
 * Check if a given object implements the SystemInfoDto interface.
 */
export function instanceOfSystemInfoDto(value?: unknown): value is SystemInfoDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(SystemInfoDtoTypeEnum)[0];
}

export function SystemInfoDtoFromJSON(json: any): SystemInfoDto {
    return SystemInfoDtoFromJSONTyped(json, false);
}

export function SystemInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemInfoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'manufacturer': ManufacturerDtoFromJSON(json['manufacturer']),
        'instructions': InstructionsDtoFromJSON(json['instructions']),
        'version': json['version'],
        'productVersion': json['productVersion'],
        'assemblyVersion': json['assemblyVersion'],
        'siteName': !exists(json, 'siteName') ? undefined : json['siteName'],
        'hostName': json['hostName'],
        'domainName': json['domainName'],
        'environmentName': json['environmentName'],
        'isPrototype': json['isPrototype'],
        'useLiveTranslations': json['useLiveTranslations'],
        'appInsightConnectionString': json['appInsightConnectionString'],
        'installationDate': json['installationDate'],
        'releaseDate': json['releaseDate'],
        'fqdn': json['fqdn'],
        'taskTypes': ((json['taskTypes'] as Array<any>).map(TaskTypeBaseFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function SystemInfoDtoToJSON(value?: SystemInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'manufacturer': ManufacturerDtoToJSON(value.manufacturer),
        'instructions': InstructionsDtoToJSON(value.instructions),
        'version': value.version,
        'productVersion': value.productVersion,
        'assemblyVersion': value.assemblyVersion,
        'siteName': value.siteName,
        'hostName': value.hostName,
        'domainName': value.domainName,
        'environmentName': value.environmentName,
        'isPrototype': value.isPrototype,
        'useLiveTranslations': value.useLiveTranslations,
        'appInsightConnectionString': value.appInsightConnectionString,
        'installationDate': value.installationDate,
        'releaseDate': value.releaseDate,
        'taskTypes': ((value.taskTypes as Array<any>).map(TaskTypeBaseToJSON)),
        '$type': value.$type,
    });
}

